function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFD561",
  x: 0,
  y: 0,
  width: 73,
  height: 73,
  rx: 22
}), /*#__PURE__*/React.createElement("path", {
  d: "M25,15 L42.1347656,15 L42.1347656,15 L46,15 C47.6568542,15 49,16.3431458 49,18 L49,57 C49,58.6568542 47.6568542,60 46,60 L25,60 C23.3431458,60 22,58.6568542 22,57 L22,18 C22,16.3431458 23.3431458,15 25,15 Z",
  id: "Rectangle",
  stroke: "#75318C",
  strokeWidth: 2,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#75318C",
  cx: 35,
  cy: 55,
  r: 2
}), /*#__PURE__*/React.createElement("text", {
  id: "LEG-WEG",
  fontFamily: "AvenirNext-Bold, Avenir Next",
  fontSize: 8,
  fontWeight: "bold",
  "line-spacing": 7,
  fill: "#DC7B53"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 27.996,
  y: 38
}, "LEG"), /*#__PURE__*/React.createElement("tspan", {
  x: 26,
  y: 45
}, "WEG")), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#75318C",
  x: 23,
  y: 16,
  width: 25,
  height: 3
})));

function SvgLegwegIconStep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegwegIconStep);
export default __webpack_public_path__ + "static/media/legweg-icon-step.d1759170.svg";
export { ForwardRef as ReactComponent };